const lightSkus15 = [
  'LGT-CHK41-NAV',
  'LGT-CHK42-CHA',
  'LGT-CHK43-FOR',
  'LGT-CHK44-SAN',
  'LGT-CHK45-CLA',
  'LGT-CHK46-SHA',
  'LGT-CHK47-OLI',
  'LGT-CHK48-CGRN',
  'LGT-CHK49-MORA',
  'LGT-CHK50-DBRO',
  'LGT-CHK51-LTAU',
  'LGT-CO1-NAV',
  'LGT-CO10-GRY',
  'LGT-CO11-OLI',
  'LGT-CO12-PIN',
  'LGT-CO13-YEL',
  'LGT-CO14-BLU',
  'LGT-CO15-CGRN',
  'LGT-CO15-MAG',
  'LGT-CO16-MORA',
  'LGT-CO17-DBRO',
  'LGT-CO18-LTAU',
  'LGT-CO2-CHA',
  'LGT-CO3-FOR',
  'LGT-CO4-SAN',
  'LGT-CO5-BUR',
  'LGT-CO6-MON',
  'LGT-CO7-CLA',
  'LGT-CO8-SKY',
  'LGT-CO9-SHA',
  'LGT-COEX21-NAV',
  'LGT-COEX22-CHA',
  'LGT-COEX23-FOR',
  'LGT-COEX24-SAN',
  'LGT-COEX25-CLA',
  'LGT-COEX26-SHA',
  'LGT-COEX27-OLI',
  'LGT-COEX28-CGRN',
  'LGT-COEX29-MORA',
  'LGT-COEX30-DBRO',
  'LGT-COEX31-LTAU',
  'LGT-COEX32-BPK',
  'LGT-PLS61-NAV',
  'LGT-PLS62-CHA',
  'LGT-PLS63-FOR',
  'LGT-PLS64-SAN',
  'LGT-PLS65-CLA',
  'LGT-PLS66-SHA',
  'LGT-PLS67-OLI',
  'LGT-PLS68-CGRN',
  'LGT-PLS69-MORA',
  'LGT-PLS70-DBRO',
  'LGT-PLS71-LTAU',
  'SET-LGT-CHKCO71-NAV',
  'SET-LGT-CHKCO72-CHA',
  'SET-LGT-CHKCO73-FOR',
  'SET-LGT-CHKCO74-SAN',
  'SET-LGT-CHKCO75-CLA',
  'SET-LGT-CHKCO76-SHA',
  'SET-LGT-CHKCO77-OLI',
  'SET-LGT-CHKCO78-CGRN',
  'SET-LGT-CHKCO79-MORA',
  'SET-LGT-CHKCO80-DBRO',
  'SET-LGT-FMLY71-NAV',
  'SET-LGT-FMLY72-CHA',
  'SET-LGT-FMLY73-FOR',
  'SET-LGT-FMLY74-SAN',
  'SET-LGT-FMLY75-CLA',
  'SET-LGT-FMLY76-SHA',
  'SET-LGT-FMLY77-OLI',
  'SET-LGT-FMLY78-CGRN',
  'SET-LGT-FMLY79-MORA',
  'SET-LGT-FMLY80-DBRO',
  'SET-LGT-PLSCO71-NAV',
  'SET-LGT-PLSCO72-CHA',
  'SET-LGT-PLSCO73-FOR',
  'SET-LGT-PLSCO74-SAN',
  'SET-LGT-PLSCO75-CLA',
  'SET-LGT-PLSCO76-SHA',
  'SET-LGT-PLSCO77-OLI',
  'SET-LGT-PLSCO78-CGRN',
  'SET-LGT-PLSCO79-MORA',
  'SET-LGT-PLSCO80-DBRO',
  'SET-LGTEX-CHKCO81-NAV',
  'SET-LGTEX-CHKCO82-CHA',
  'SET-LGTEX-CHKCO83-FOR',
  'SET-LGTEX-CHKCO84-SAN',
  'SET-LGTEX-CHKCO85-CLA',
  'SET-LGTEX-CHKCO86-SHA',
  'SET-LGTEX-CHKCO87-OLI',
  'SET-LGTEX-CHKCO88-CGRN',
  'SET-LGTEX-CHKCO89-MORA',
  'SET-LGTEX-CHKCO90-DBRO',
  'SET-LGTEX-FMLY71-NAV',
  'SET-LGTEX-FMLY72-CHA',
  'SET-LGTEX-FMLY73-FOR',
  'SET-LGTEX-FMLY74-SAN',
  'SET-LGTEX-FMLY75-CLA',
  'SET-LGTEX-FMLY76-SHA',
  'SET-LGTEX-FMLY77-OLI',
  'SET-LGTEX-FMLY78-CGRN',
  'SET-LGTEX-FMLY79-MORA',
  'SET-LGTEX-FMLY80-DBRO',
  'SET-LGTEX-PLSCO71-NAV',
  'SET-LGTEX-PLSCO72-CHA',
  'SET-LGTEX-PLSCO73-FOR',
  'SET-LGTEX-PLSCO74-SAN',
  'SET-LGTEX-PLSCO75-CLA',
  'SET-LGTEX-PLSCO76-SHA',
  'SET-LGTEX-PLSCO77-OLI',
  'SET-LGTEX-PLSCO78-CGRN',
  'SET-LGTEX-PLSCO79-MORA',
  'SET-LGTEX-PLSCO80-DBRO'
];

const auLookUp = {
  20: [...lightSkus15]
}
const usLookUp = {
  20: [...lightSkus15]
}

const nzLookUp = {
  20: [...lightSkus15]
}
const ukLookUp = {
  20: [...lightSkus15]
}
const caLookUp = {
  20: [...lightSkus15]
}

const skusDiscounts = (locale) => {
  return Object.entries(locale).reduce((skuData, [amount, SKUs]) => {
    SKUs.forEach(SKU => {
      skuData[SKU] = { type: 'percentage', amount: parseInt(amount) };
    });
    return skuData;
  }, {});
};

const AU = skusDiscounts(auLookUp);
const US = skusDiscounts(usLookUp);
const NZ = skusDiscounts(nzLookUp);
const UK = skusDiscounts(ukLookUp);
const CA = skusDiscounts(caLookUp);

export default { 'en-AU': AU, en: US, 'en-NZ': NZ, 'en-GB': UK, 'en-CA': CA }